angular.module('aprima-core-ui')
    .directive('stRatio', ['$parse', function($parse) {
        'use strict';

        return {
            link: function (scope, element, attr) {
                var ratio = $parse(attr.stRatio)(scope);

                element.css('width', ratio + '%');
            }
        };
    }]);